var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"background-color":"#000000","blur":"","color":"#0068B4","opacity":0.4},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }